import { ICustomerVehicle } from "JS/types/Automotive";
import { ITireRecommendationQuestion } from "../types/TireRecommendation.types";
import { v4 as uuid } from "uuid";

// These questions were originally going to be persisted in the database and managed via the ACP
// However, discussions with Blain's team and timeline of the project determined it was
// not worth the time and effort. So here they are in all of their hardcoded glory
export function getTireQuestionsForVehicle(vehicle: ICustomerVehicle): ITireRecommendationQuestion[] {
	const questions: ITireRecommendationQuestion[] = [{
		id: uuid(),
		description: "How many miles per year do you drive?",
		selectListLabel: "Number of Miles",
		answers: [
			{	id: uuid(),
				description: "Less Than 10,000",
				warrantyFactor: 5000,
				solo: true
			},
			{	id: uuid(),
				description: "10,000 - 20,000",
				warrantyFactor: 10000,
				solo: true
			},
			{	id: uuid(),
				description: "Over 20,000",
				warrantyFactor: 20000,
				solo: true
			},
			{
				id: uuid(),
				description: "I Don't know",
				warrantyFactor: 10000,
				solo: true
			}
		]
	},
	{
		id: uuid(),
		description: "How long do you plan to keep your vehicle?",
		selectListLabel: "Number of Years",
		answers: [
			{	id: uuid(),
				description: "Less Than 6 Months",
				warrantyFactor: 0.5,
				solo: true
			},
			{	id: uuid(),
				description: "1-2 Years",
				warrantyFactor: 1,
				solo: true
			},
			{	id: uuid(),
				description: "3-5 Years",
				warrantyFactor: 3,
				solo: true
			},
			{	id: uuid(),
				description: "5 or More Years",
				warrantyFactor: 5,
				solo: true
			},
			{	id: uuid(),
				description: "I Don't Know",
				warrantyFactor: 1,
				solo: true
			}
		]
	}];

	if (vehicle?.prefix !== 'LT') return questions;

	questions.push({
		id: uuid(),
		description: "Do you use your vehicle for any of the following?",
		selectListLabel: "Driving Application",
		answers: [
			{
				id: uuid(),
				description: "Off Road",
				warrantyFactor: 1,
				offRoad: true,
				solo: false
			},
			{
				id: uuid(),
				description: "Hauling or Towing",
				warrantyFactor: 1,
				towing: true,
				solo: false
			},
			{
				id: uuid(),
				description: "Not Applicable",
				warrantyFactor: 1,
				solo: true
			}
		]
	});
	return questions;
}